import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { usersDropdownListFetch } from 'actions';
import { isArray, isEmpty, map, find, isEqual } from 'lodash';
import { CustomDropdownContainer } from 'CommonComponent';

const UserDropdown = ({
  selectedId = '',
  selectedChangingId = '',
  userValue,
  setUserValue,
  userOnChange,
  setAllUserIds,
  showSelectAllOption = true,
  isMulti = true,
  placeholder = 'Select User',
  label = 'User',
  name = 'user_id',
  error = '',
  usersToshow = 'internal',
  programId,
  loadManagerProgramUsers = false,
  loadUnbindedOnly,
}) => {
  const dispatch = useDispatch();
  const session = useSelector((s) => s.session);
  const usersState = useSelector((state) => state.userState);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const userList = usersState.usersDropdownList;

  useEffect(() => {
    if (!selectedChangingId || !userList) return;

    if (isArray(selectedChangingId)) {
      const selected = selectedChangingId.map(id =>
        find(userList, ['id', id])
      ).filter(Boolean).map(item => ({ value: item.id, label: item.name || item.email, type: item.type }));
      setUserValue(selected);
    } else {
      const selected = find(userList, ['id', selectedChangingId]);
      setUserValue(selected ? { value: selected.id, label: selected.name || selected.email, type: selected.type } : null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedChangingId, userList]);


  useEffect(() => {
    if (!userList) return;

    const formattedOptions = map(userList, item => ({
      value: item.id,
      label: item.name || item.email,
      type: item.type,
    }));

    if (showSelectAllOption && isMulti) {
      formattedOptions.unshift({ value: 'all', label: 'All' });
    }

    setOptions(formattedOptions);

    if (typeof setAllUserIds === 'function') {
      setAllUserIds(map(userList, 'id'));
    }

    if (!isEmpty(selectedId)) {
      if (isArray(selectedId)) {
        const selected = selectedId.map(id =>
          find(formattedOptions, ['value', id])
        ).filter(Boolean);

        if (!isEqual(userValue, selected)) {
          setUserValue(selected);
        }
      } else {
        const selected = find(formattedOptions, ['value', selectedId]);
        if (!isEqual(userValue, selected)) {
          setUserValue(selected || null);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userList, selectedId, isMulti, showSelectAllOption]);

  const formatOptionLabel = ({ label, type }) => (
    <div>
      {label}
      {usersToshow === 'both' && type && ` (${type})`}
    </div>
  );

  const fetchUser = () => {

      let params = {
        object_viewed_id: session?.current_page_permissions?.object_id || '',
        usersToshow,
        load_manager_program_users: loadManagerProgramUsers
      };
  
      if(programId !== undefined && programId !== null){
        if(loadUnbindedOnly !== undefined ){
          params.load_unbinded_only = loadUnbindedOnly;
        }
        else{
          params.load_unbinded_only = true;
        }
        
        params.program_id = programId;
      }
  
      dispatch(usersDropdownListFetch(params));
  
  }

  return (
    <>
      <Form.Group className="mb-3">
        {label && <Form.Label className="label-input">{label}</Form.Label>}
        <Select
          name={name}
          options={options}
          value={userValue}
          onChange={userOnChange}
          isMulti={isMulti}
          placeholder={placeholder}
          className="multi-select w-100"
          classNamePrefix="react-select"
          isSearchable
          components={{ ValueContainer: CustomDropdownContainer }}
          formatOptionLabel={formatOptionLabel}
        />
        {error && <div className="invalid-feedback d-block">{error}</div>}
      </Form.Group>
    </>
  );
};

UserDropdown.propTypes = {
  userOnChange: PropTypes.func.isRequired,
  setUserValue: PropTypes.func.isRequired,
  userValue: PropTypes.any,
  selectedId: PropTypes.any,
  selectedChangingId: PropTypes.any,
  setAllUserIds: PropTypes.func,
  isMulti: PropTypes.bool,
  showAll: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.string,
  usersToshow: PropTypes.oneOf(['internal', 'external', 'both']),
  showSelectAllOption: PropTypes.bool,
};

export default UserDropdown;
